import * as styles from './styles';
import L from 'leaflet';

import flagIconUrl from '../icons/ic_flag.svg';

export const EndIcon = new L.DivIcon({
  html: `<div class="${styles.icon}"><img src="${flagIconUrl}" /></div>`,
  iconSize: [30, 30],
  iconAnchor: [15, 15],
});
